<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.02439 5C1.02439 3.96041 1.92237 3 3 3H10C11.0776 3 12 3.96041 12 5V5.99963H19C20.0776 5.99963 21 6.96003 21 7.99963V17C21 18.0396 20.0776 19 19 19H3C1.92237 19 1 18.0396 1 17L1.02439 5ZM3 4C2.46119 4 2 4.4802 2 5V17C2 17.5198 2.46119 18 3 18H19C19.5388 18 20 17.5198 20 17V7.99963C20 7.47983 19.5388 6.99963 19 6.99963H10.9926V5C10.9926 4.4802 10.5388 4 10 4H3Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGFolder',
};
</script>

<style scoped lang="scss">

</style>
